import '../css/style-1.css';
import '../css/style-2.css';
import '../css/style.css';

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import coimbatorepath from "../images/images-1/coimbatore.jpg";
import prozone from "../images/images-1/prozone.jpg";
import radiance from "../images/images-1/radiance-splendour.jpg";
import cosmos from "../images/images-1/casagrand-cosmos.jpg";
import city from "../images/images-1/gsquare-city.jpg";
import blossom from"../images/images-1/gsquare-blossom.jpg";
import pride from"../images/images-1/gsquare-pride.jpg";
import ghats from"../images/images-1/gsquare-western-ghats.jpg"
import kosmos from"../images/images-1/kosmo.jpg"
import tvhcrest from "../images/images-1/tvhcrest.jpg";
import tvhSerenity from "../images/images-1/tvhserenity.jpg";

import CasagrandSpacio from "../images/images-1/Casagrand-Spacio.jpg";
import CasagrandAscentia from "../images/images-1/CasagrandAscentia.webp"
import CasagrandKeystone from "../images/images-1/CasagrandKeystone.jpg"
import CasagrandOrchardsVillaPH2 from "../images/images-1/CasagrandOrchardsVillaPH2.png"
import CasagrandCelest from "../images/images-1/CasagrandCelest.jpg"
import CasagrandOrchardsPhase1 from "../images/images-1/CasagrandOrchardsPhase1.jpg";
import CasagrandColosseum from "../images/images-1/CasagrandColosseum.png";
import CasagrandAlpine from "../images/images-1/CasagrandAlpine.jpg";

import RadianceRiverwoods from "../images/images-1/RadianceRiverwoods.jpg";
import RadianceImperia from "../images/images-1/RadianceImperia.png";

import InfiniumLotusMeadows from "../images/images-1/InfiniumLotusMeadows.webp";
import InfiniumCentral16 from "../images/images-1/InfiniumCentral16.webp";
import InfiniumCrimsonCrest from "../images/images-1/InfiniumCrimsonCrest.jpg";
import InfiniumSky9 from "../images/images-1/InfiniumSky9.jpg";

import GoldenGrove from "../images/images-1/GoldenGrove.avif";

import Turin from "../images/images-1/Turin.jpeg";
import Patio from "../images/images-1/Patio.jpg";

import DACThulir from "../images/images-1/DACThulir.jpg";

import Cta from '../sections/Cta';

function Coimbatore(){
const properties = [
      {
        image: DACThulir,
        badge: "2 & 3 BHK Apartments",
        title: "DAC Thulir",
        location: "GN MILLS, COIMBATORE",
        details: {
          type: "Premium Apartment Community",
          size: "2 & 3 BHK Apartments",
          place: "GN Mills, Coimbatore",
          price: "₹ 65 Lakhs Onwards"
        },
        overview:
          "DAC Thulir is a premium residential community located in GN Mills offering 54 thoughtfully designed 2 & 3 BHK apartments. Built in an S + 5 floor structure, the project features homes ranging from 976 sq.ft to 1460 sq.ft designed with modern architecture and eco-friendly elements. The community focuses on providing a balanced lifestyle with a blend of comfort, convenience, and natural surroundings.",
        amenities: [
          "Indoor Games Room",
          "Association Room",
          "Air Conditioned Gym",
          "Kids Play Area",
          "Senior Citizen Zone",
          "Pergola Seating",
          "Sitout Area",
          "Herb Garden with Seating",
          "Yoga Meditation Zone",
          "BBQ Corner"
        ]
      },
      {
        image: Patio,
        badge: "1 & 2 BHK Apartments",
        title: "Patio",
        location: "COIMBATORE",
        details: {
          type: "Premium Apartment Community",
          size: "1 & 2 BHK Apartments",
          place: "Coimbatore",
          price: "Price On Request"
        },
        overview:
          "Patio is a premium apartment community in Coimbatore offering 1 & 2 BHK homes with unit sizes ranging from 544 to 876 sq.ft. Designed to deliver a balance of comfort and affordability, the project features thoughtfully planned living spaces with modern design elements. The development focuses on providing a refined lifestyle experience in a well-connected location.",
        amenities: [
          "Gym",
          "Night View Area",
          "Party Wall",
          "Indoor Game",
          "Swimming Pool",
          "Multipurpose Hall",
          "Podium Garden with Seating Area"
        ]
      },
      {
        image: Turin,
        badge: "2 & 3 BHK Apartments",
        title: "Turin",
        location: "COIMBATORE",
        details: {
          type: "Premium Apartment Community",
          size: "2 & 3 BHK Apartments",
          place: "Coimbatore",
          price: "Price On Request"
        },
        overview:
          "Turin is an Italian-inspired premium apartment community in Coimbatore offering 2 & 3 BHK homes. Designed with refined architecture and elegant interiors, the project focuses on modern living with thoughtfully planned spaces. Inspired by the timeless charm of Turin city, the development brings a sophisticated residential experience with a blend of style and comfort.",
        amenities: [
          "Gym",
          "Night View Area",
          "Party Wall",
          "Indoor Game",
          "Swimming Pool",
          "Multipurpose Hall",
          "Podium Garden with Seating Area"
        ]
      },
      {
        image: GoldenGrove,
        badge: "DTCP Approved Villa Plots",
        title: "Pressana Infra Golden Grove",
        location: "NANJUNDAPURAM, COIMBATORE",
        details: {
          type: "Gated Community Villa Plots",
          size: "Villa Plots",
          place: "Nanjundapuram, Coimbatore",
          price: "Price On Request"
        },
        overview:
          "Golden Grove by Pressana Infra is a DTCP & RERA-approved gated community spread across 14.45 acres in Nanjundapuram, Coimbatore. The project offers 216 thoughtfully planned villa plots ranging from 1.27 cents to 6.55 cents designed for comfortable residential living. With strong connectivity to key areas of the city and surrounded by essential infrastructure, the community provides a balanced environment for both living and long-term investment.",
        amenities: [
          "Gated Community",
          "Blacktop Roads",
          "Street Lights",
          "Landscaped Green Spaces",
          "Children’s Play Area",
          "Walking Pathways",
          "Security Surveillance"
        ]
      },
      {
        image: InfiniumSky9,
        badge: "2 & 3 BHK Apartments",
        title: "Infinium Sky9",
        location: "GOLDWINS, COIMBATORE",
        details: {
          type: "Premium Apartment Community",
          size: "2 & 3 BHK Apartments",
          place: "Goldwins, Coimbatore",
          price: "₹76 Lacs Onwards"
        },
        overview:
          "Infinium Sky9 is a high-rise residential community located on Veeriyampalayam Road, Goldwins just 2 minutes from Avinashi Road. Spread across 2.16 acres, the project offers 216 thoughtfully designed 2 & 3 BHK apartments built in a Basement + Stilt + 9 floor structure. The community features 35 lifestyle amenities and a 10,000 sq.ft clubhouse designed to provide a modern and comfortable living experience.",
        amenities: [
          "Swimming Pool",
          "Kids Pool",
          "Indoor Gym",
          "Indoor Games Room",
          "Indoor Kids Play Area",
          "Mini Theatre",
          "Party Hall",
          "Yoga Room",
          "Aerobics Room",
          "Business Centre",
          "Grocery Store",
          "Ironing Space",
          "School Bus Bay",
          "Walking & Jogging Track",
          "Turf (Football / Cricket)",
          "Badminton Court",
          "Elders Plaza",
          "Rock Climbing Wall",
          "Outdoor Children's Play Area",
          "Trampoline",
          "Entry Plaza with Seater",
          "Water Feature Wall",
          "Outdoor Gym",
          "Restroom for Househelp and Drivers",
          "Rainwater Harvesting",
          "Sewage Treatment Plant",
          "Water Softening Plant"
        ]
      },
      {
        image: InfiniumCrimsonCrest,
        badge: "2 & 3 BHK Apartments",
        title: "Infinium Crimson Crest",
        location: "TIDEL PARK AREA, COIMBATORE",
        details: {
          type: "Premium Apartment Community",
          size: "2 & 3 BHK Apartments",
          place: "Tidel Park Area, Coimbatore",
          price: "₹85 Lacs Onwards"
        },
        overview:
          "Infinium Crimson Crest is a premium residential community spread across 1.50 acres with 130 apartments. Built in a Basement + Ground + 5 floor structure, the project offers spacious 2 & 3 BHK apartments ranging from 1225 sq.ft to 1520 sq.ft. Located close to Tidel Park, the community provides 40+ lifestyle amenities and a 15,000 sq.ft grand clubhouse designed to offer a comfortable and modern living experience.",
        amenities: [
          "Swimming Pool",
          "Kid's Pool",
          "Badminton Court",
          "Turf",
          "Outdoor Gym",
          "Children’s Play Area",
          "Dining Deck",
          "Pebble Bed",
          "Yoga Deck",
          "Meditation Lawn",
          "Deck with Lounge Seating",
          "Rooftop Barbeque Lawn",
          "Trampoline",
          "Rock Climbing Wall",
          "Reflexology Pathway",
          "Party Lawn",
          "Croquet Court",
          "Outdoor Stage with Feature Wall",
          "Toddler’s Park",
          "Outdoor Chess",
          "Sensory Floor Game",
          "Elder Plaza with Seater",
          "Podium with Ample Seater and Greenery",
          "Gym",
          "Game Room",
          "Mini Theatre",
          "Party Hall"
        ]
      },

      {
        image: InfiniumCentral16,
        badge: "4 BHK Villas",
        title: "Infinium Central 16",
        location: "SINGANALLUR, COIMBATORE",
        details: {
          type: "Luxury Villa Community",
          size: "4 BHK Villas",
          place: "Singanallur, Coimbatore",
          price: "₹4.50 Crs Onwards"
        },
        overview:
          "Infinium Central 16 is an ultra-luxurious villa community spread across 1.42 acres offering 16 exclusive 4 BHK villas. Inspired by Mediterranean architecture, the villas are designed with spacious layouts, indoor-outdoor living concepts, abundant natural light, and breezy interiors suited to Coimbatore’s climate. The development combines premium design with thoughtfully planned amenities to create an elegant and private residential environment.",
        amenities: [
          "Party Hall",
          "Indoor Gym",
          "Indoor Games Room",
          "Barbeque Station",
          "Aroma Garden",
          "Rainwater Harvesting",
          "UG Sump with Water Softening Plant",
          "CCTV Surveillance",
          "24x7 Security",
          "Intercom",
          "Outdoor Landscape",
          "Well-defined Driveway",
          "App-based Entry / Exit Controls",
          "Common Area & Compound Wall Lighting",
          "Solar Water Heaters for Every Villa",
          "Private Garden"
        ]
      },

      {
        image: InfiniumLotusMeadows,
        badge: "2, 3 & 4 BHK Villas & Apartments",
        title: "Infinium Lotus Meadows",
        location: "SARAVANAMPATTI, COIMBATORE",
        details: {
          type: "Premium Villa & Apartment Community",
          size: "2, 3 & 4 BHK Villas & Apartments",
          place: "Saravanampatti, Coimbatore",
          price: "₹80 L Onwards"
        },
        overview:
          "Infinium Lotus Meadows is a premium residential community in Saravanampatti spread across 4.21 acres with 104 units including 39 villas and 65 apartments. The project offers 3 & 4 BHK villas and 2 & 3 BHK apartments designed with spacious layouts and Vaastu-friendly planning. With 60% open space and 50+ lifestyle amenities, the community provides a balanced environment combining modern living with serene surroundings.",
        amenities: [
          "Indoor Gym",
          "Multipurpose Hall",
          "Mini Theatre",
          "Indoor Games Room",
          "Aerobics Lounge",
          "Business Centre",
          "Arrival Plaza with Shade Structure",
          "Bus Pickup Zone",
          "KOI Pond",
          "Lotus Leaf Structure",
          "Pedestrian Pathway",
          "Outdoor Gym",
          "Sculpture Court",
          "Kid's Play Area",
          "Outdoor Board Games",
          "Rock Climbing Wall",
          "Herb Garden",
          "Elder's Court",
          "Mini Soccer",
          "Cricket Turf",
          "Badminton Court",
          "Pickle Ball Court",
          "Stage with Feature Wall",
          "Lotus Plaza",
          "Multi-Level Deck",
          "Thematic Garden"
        ]
      },
      {
        image: RadianceImperia,
        badge: "3, 3.5, 4 & 5 BHK Villas",
        title: "Radiance Imperia",
        location: "VEERAKERALAM, COIMBATORE",
        details: {
          type: "Luxury Villa Community",
          size: "3, 3.5, 4 & 5 BHK Villas",
          place: "Veerakeralam, Coimbatore",
          price: "₹2.27 Cr Onwards"
        },
        overview:
          "Radiance Imperia is a luxury villa community in Veerakeralam, Coimbatore spread across 8.17 acres with 80 independent villas. The project offers 3, 3.5, 4 & 5 BHK villas with home theatre rooms designed with premium specifications and modern features. The community combines spacious layouts, landscaped surroundings, and a wide range of lifestyle amenities to create an exclusive residential environment.",
        amenities: [
          "Kids Play Area",
          "Sand Pit",
          "Trampoline",
          "Futsal Court",
          "Cricket Net Practice",
          "Tennis Court",
          "Open Party Lawn",
          "Open Amphitheatre",
          "Rock Climbing Wall",
          "Reflexology Pathway",
          "Skating Rink",
          "Walking Track",
          "Outdoor Gym",
          "Hammock",
          "BBQ Counter",
          "Gym",
          "Coffee Bar",
          "Association Room",
          "Yoga / Zumba",
          "Spa",
          "Steam",
          "Sauna",
          "Jacuzzi",
          "Reading Room",
          "More.."
        ]
      },

      {
        image: RadianceRiverwoods,
        badge: "1, 2 & 3 BHK Apartments",
        title: "Radiance Riverwoods",
        location: "PERUR MAIN ROAD, COIMBATORE",
        details: {
          type: "Premium Apartment Community",
          size: "1, 2 & 3 BHK Apartments",
          place: "Perur Main Road, Coimbatore",
          price: "₹54 L to ₹1.21 Cr"
        },
        overview:
          "Radiance Riverwoods is a residential community located on Perur Main Road, Coimbatore spread across 3 acres with 377 apartments. Built in a Basement + Stilt + 13 floor structure, the project offers thoughtfully designed 1, 2 & 3 BHK apartments. Surrounded by greenery near the Western Ghats and Noyyal River, the community provides a nature-rich environment with modern living spaces and convenient access to major city locations.",
        amenities: [
          "Mini Amphitheatre",
          "Adventure Zone / Climber",
          "Kids Play Area",
          "Party Lawn / Multifunctional",
          "Outdoor Gym",
          "Reflexology Pathway",
          "Senior Citizens Alcove",
          "Mini Basketball Hoop",
          "Swimming Pool / Kids Pool",
          "Aroma Plantation",
          "Bamboo Grooves",
          "Seating Alcoves",
          "Barbeque Plaza",
          "Raised Palm Deck",
          "Yoga Zone / Meditation"
        ]
      },
      {
        image: CasagrandAlpine,
        badge: "2 & 3 BHK Apartments",
        title: "Casagrand Alpine",
        location: "KEERANATHAM, COIMBATORE",
        details: {
          type: "Premium Apartment Community",
          size: "2 & 3 BHK Apartments",
          place: "Keeranatham, Coimbatore",
          price: "₹71L - ₹98 L"
        },
        overview:
          "Casagrand Alpine is a residential community in Keeranatham spread across 1.4 acres offering 144 thoughtfully designed 2 & 3 BHK apartments. Built in a Stilt + 5 floor structure, the project features a contemporary façade and modern interiors with 20+ indoor and outdoor lifestyle amenities. The community is designed to provide a comfortable living environment with recreational spaces and thoughtfully planned homes for modern living.",
        amenities: [
          "Futsal Court with Seating Gallery",
          "Outdoor Gym",
          "Outdoor Yoga / Meditation Deck",
          "Kids Hive",
          "Tot-Lot",
          "Trampoline",
          "Leisure Pavilions",
          "Jungle Gym",
          "Party Lawn with Dias",
          "Barbecue Counter with Seater"
        ]
      },

      {
        image: CasagrandColosseum,
        badge: "4 BHK Villas",
        title: "Casagrand Colosseum",
        location: "AVARAMPALAYAM, COIMBATORE",
        details: {
          type: "Premium Villa Community",
          size: "4 BHK Villas",
          place: "Avarampalayam, Coimbatore",
          price: "₹6.66Cr to 6.86Cr"
        },
        overview:
          "Casagrand Colosseum is an exclusive residential community in Avarampalayam spread across 2.6 acres with 48 premium homes. The project features palatially designed 4 BHK signature villas with G+2 floors along with stylish apartments in a B+G+5 structure. With 77% open space, the development ensures a spacious environment with thoughtfully designed homes featuring private home theatre rooms and premium specifications. The community also offers 15+ world-class amenities including a 2500 sft swimming pool, sky cinema, gym, and landscaped spaces for a refined lifestyle.",
        amenities: [
          "Entrance plaza",
          "Trellis walkway",
          "Elderly seating pavilion",
          "Cycling track for kids",
          "Walking / Jogging track"
        ]
      },

      {
        image: CasagrandOrchardsPhase1,
        badge: "2 & 3 BHK Apartments",
        title: "Casagrand Orchards Phase I",
        location: "KANNAMPALAYAM, COIMBATORE",
        details: {
          type: "Premium Apartment Community",
          size: "2 & 3 BHK Apartments",
          place: "Kannampalayam, Coimbatore",
          price: "₹71 L to ₹99 L"
        },
        overview:
          "Casagrand Orchards Phase I is a classical-themed residential community in Kannampalayam, Coimbatore spread across 9.52 acres. Phase 1 features 207 thoughtfully designed 2 & 3 BHK apartments built in a Basement + Ground + 5 floor structure with a classical façade and elegant entrance arch. The community offers over 56% landscaped open space along with 45+ premium amenities including a rooftop sky cinema, BBQ pit, gym, and a 4,700 sq. ft. swimming pool with deck. A 7,000 sq. ft. clubhouse with double-height lobby further enhances the lifestyle experience.",
        amenities: [
          "Tot-Lot",
          "Kids Play Court",
          "Kids Sand Pit",
          "Tyre Swings",
          "Outdoor Reading & Board Games Plaza",
          "Cycling Track",
          "Walking / Jogging Track",
          "Reflexology Pathway"
        ]
      },

      {
        image: CasagrandCelest,
        badge: "2 & 3 BHK Apartments",
        title: "Casagrand Celest – Premium 2 & 3 BHK Apartments",
        location: "SULUR, COIMBATORE",
        details: {
          type: "Premium Apartment Community",
          size: "2 & 3 BHK Apartments",
          place: "Sulur, Coimbatore",
          price: "₹ 56L to ₹ 70L"
        },
        overview:
          "Casagrand Celest is a premium residential community in Sulur, Coimbatore spread across 2.66 acres offering 223 thoughtfully designed 2 & 3 BHK apartments. The project features 66% open space with a 33,000 sq.ft landscaped podium and 35+ premium amenities for a vibrant community lifestyle. A 5800 sq.ft ultra-luxury clubhouse and a 4200 sq.ft swimming pool enhance the living experience. The vehicle-free podium ensures a safe and comfortable environment within the community.",
        amenities: [
          "Multipurpose sports court with mini gallery seating",
          "Multi Hoop Basketball Court",
          "Outdoor crossfit court",
          "Walking / Jogging track",
          "Cycling track"
        ]
      },

      {
        image: CasagrandOrchardsVillaPH2,
        badge: "3 & 4 BHK Villas",
        title: "Casagrand Orchards Villa – PH II",
        location: "KANNAMPALAYAM, COIMBATORE",
        details: {
          type: "Premium Villa Community",
          size: "3 & 4 BHK Villas",
          place: "Kannampalayam",
          price: "₹ 1.60 Cr to ₹ 2.25 Cr"
        },
        overview:
          "Casagrand Orchards Villa – PH II is a classical-themed villa community in Kannampalayam spread across 9.52 acres with 115 premium villas. The project offers elegantly designed 3 & 4 BHK independent villas with a focus on light, ventilation, vaastu, privacy, and aesthetics. The community features 5.6 acres of open space with 3 acres of lush greenery and a tropical forest along with 45+ indoor and outdoor amenities. A 13,000 sqft grand club with a 6,000 sqft clubhouse enhances the lifestyle experience in this thoughtfully planned residential enclave.",
        amenities: [
          "Tot-Lot",
          "Kids Play Court",
          "Kids Sand Pit",
          "Tyre Swings",
          "Outdoor Reading & Board Games Plaza"
        ]
      },
      {
        image: CasagrandKeystone,
        badge: "2 & 3 BHK Apartments",
        title: "Casagrand Keystone Premium 2 & 3 BHK Apartments",
        location: "RAKKIYAPALAYAM, TIRUPPUR, COIMBATORE",
        details: {
          type: "Premium Apartment Community",
          size: "2 & 3 BHK Apartments",
          place: "Rakkiyapalayam, Tiruppur",
          price: "₹ 68L - ₹ 99L"
        },
        overview:
          "Casagrand Keystone is a classic styled residential community spread across 2.2 acres in Rakkiyapalayam, Tiruppur offering 142 thoughtfully designed 2 & 3 BHK apartments. Built across B + G + 5 floors, the project features 48 indoor and outdoor amenities, a 6800 sft clubhouse, and a spacious 24,500 sft podium. With 1.3 acres of open space and 51,000 sft of lush greenery, the community creates a balanced environment for comfortable and modern living.",
        amenities: [
          "Multi-purpose Hall",
          "Gym",
          "Home Theatre / AV Room",
          "Kids Play Area",
          "Art Board",
          "Rock Climbing Wall",
          "Foosball",
          "Table Tennis",
          "Board & Video Games"
        ]
      },
      {
        image: CasagrandAscentia,
        badge: "2 & 3 BHK Apartments",
        title: "Casagrand Ascentia – Premium 2 & 3 BHK Apartments",
        location: "SARAVANAMPATTI, COIMBATORE",
        details: {
          type: "Premium Apartment Community",
          size: "2 & 3 BHK Apartments",
          place: "Saravanampatti, Coimbatore",
          price: "₹ 65 L Onwards"
        },
        overview:
          "Casagrand Ascentia is a premium 4-acre residential community in Saravanampatti, Coimbatore offering 238 thoughtfully designed 2 & 3 BHK apartments. Planned with a focus on light, ventilation, Vaastu, privacy, and aesthetics, the project features 51 indoor and outdoor amenities, 33,000 sft of landscaped podium spaces, 2.2 acres of open areas, and a 3800 sft swimming pool. Built in a B+G+5 floor structure with a classical-style façade and tropical-themed landscape, the community also includes an 8200 sft clubhouse and a vehicle-free podium with basement parking.",
        amenities: [
          "Multi-purpose hall",
          "Gym",
          "Home theatre / AV room",
          "Kids play area",
          "Trampoline",
          "Balls pool",
          "Climbing wall",
          "Foosball",
          "Table tennis room",
          "Board & video games"
        ]
      },
      {
        image: CasagrandSpacio,
        badge: "4 BHK Premium Villas",
        title: "Casagrand Spacio – Luxury 4 BHK Villas",
        location: "CHETTIPALAYAM, TIRUPUR, COIMBATORE",
        details: {
          type: "Premium Villa Community",
          size: "4 BHK Villas",
          place: "Chettipalayam, Tiruppur",
          price: "₹ 2.49 Cr Onwards"
        },
        overview:
          "Casagrand Spacio is a premium European-styled villa community in Chettipalayam, Tiruppur, spread across 2 acres with only 20 exclusive 4 BHK villas. Designed for spacious and elegant living, the project offers thoughtfully planned homes with maid rooms, landscaped open spaces, and a peaceful residential environment. With 65% open space and a host of lifestyle amenities, it delivers a refined and comfortable living experience.",
        amenities: [
          "Clubhouse",
          "Landscaped Green Spaces",
          "Wellness Reflex Path",
          "Senior Serenity Court",
          "Party Lawn with Dias",
          "Earth Hammock",
          "Leisure Path",
          "Multi-purpose Court with Hoop Hub",
          "Fragrance Lounge with Seating"
        ]
      },
      {
        image: tvhSerenity,
        badge: "Premium 2 BHK Flats",
        title: "TVH Serenity – Premium 2 BHK Flats",
        location: "AVINASHI, COIMBATORE",
        details: {
          type: "Residential Apartments",
          size: "2 BHK – 868 – 1055 Sqft",
          place: "Avinashi",
          price: "₹ 56.5 Lakhs Onwards"
        },
        overview:
          "TVH Serenity offers thoughtfully designed 2 BHK apartments in Avinashi, Coimbatore with spacious layouts and modern living spaces.",
        amenities: [
          "Gated Community",
          "24/7 Security",
          "Covered Car Parking",
          "Power Backup",
          "Lift Facility",
          "Children’s Play Area",
          "Landscaped Garden",
          "CCTV Surveillance"
        ]
      },

      {
        image: tvhcrest,
        badge: "1 & 2 BHK Apartments",
        title: "TVH Crest – Premium 1 & 2 BHK Apartments",
        location: "AVINASHI, COIMBATORE",
        details: {
          type: "Residential Apartments",
          size: "1 BHK – 784 SqFt | 2 BHK – 1038 – 1154 SqFt",
          place: "Avinashi",
          price: "1 BHK – ₹52.53 Lakhs | 2 BHK – ₹69.53 Lakhs"
        },
        overview:
          "TVH Crest offers modern 1 and 2 BHK apartments designed for comfortable urban living in Avinashi, Coimbatore.",
        amenities: [
          "Gated Community",
          "24/7 Security",
          "Covered Car Parking",
          "Lift Facility",
          "Power Backup",
          "Children’s Play Area",
          "Landscaped Garden",
          "CCTV Surveillance"
        ]
      },

      {
        image: ghats,
        badge: "Residential Plots",
        title: "G Square Western Ghats Premium Residential Plots",
        location: "PALANTHURAI ROAD, COIMBATORE",
        details: {
          type: "Residential Plots",
          size: "3 - 4 Cents",
          place: "Palanthurai Road",
          price: "DTCP Approved"
        },
        overview:
          "G Square Western Ghats offers premium residential plots in a peaceful environment with excellent connectivity.",
        amenities: [
          "Blacktop Internal Roads",
          "Street Lighting",
          "24/7 Security",
          "Gated Community",
          "Rainwater Harvesting",
          "Children’s Play Area"
        ]
      },

      {
        image: blossom,
        badge: "Residential Plots",
        title: "G Square Blossom Premium Residential Plots",
        location: "AVINASHI, COIMBATORE",
        details: {
          type: "Residential Plots",
          size: "3 - 4 Cents",
          place: "Avinashi",
          price: "₹19.50 Lakhs Onwards"
        },
        overview:
          "G Square Blossom offers well-planned residential plots in Avinashi with DTCP approval and excellent connectivity.",
        amenities: [
          "Gated Community",
          "Street Lights",
          "Blacktop Roads",
          "Water Line Provision",
          "Rainwater Harvesting",
          "Children’s Play Area"
        ]
      },

      {
        image: pride,
        badge: "Residential Plots",
        title: "G Square Pride TVS Nagar Premium Residential Plots",
        location: "EDAYARPALAYAM, COIMBATORE",
        details: {
          type: "Residential Plots",
          size: "3 - 6 Cents",
          place: "Edayarpalayam",
          price: "₹30 Lakhs Onwards"
        },
        overview:
          "G Square Pride offers DTCP approved residential plots in a fast growing locality of Coimbatore.",
        amenities: [
          "Gated Community",
          "Blacktop Roads",
          "Street Lighting",
          "24/7 Security",
          "Children’s Play Area",
          "Rainwater Harvesting"
        ]
      },

      {
        image: city,
        badge: "Residential Plots",
        title: "G Square City Premium Residential Plots",
        location: "L&T BYPASS, COIMBATORE",
        details: {
          type: "Residential Plots",
          size: "3 - 4 Cents",
          place: "L&T Bypass",
          price: "₹57 Lakhs Onwards"
        },
        overview:
          "G Square City offers strategically located residential plots along L&T Bypass with excellent future value.",
        amenities: [
          "Gated Community",
          "Street Lighting",
          "Blacktop Roads",
          "Drainage System",
          "Children’s Play Area",
          "Green Open Spaces"
        ]
      },

      {
        image: radiance,
        badge: "Luxury Villas",
        title: "Radiance Splendour – 3 & 4 BHK Luxury Villas",
        location: "VEDAPATTI, COIMBATORE",
        details: {
          type: "Villa",
          size: "3 & 4 BHK",
          place: "Vedapatti",
          price: "₹36 Lakhs Onwards"
        },
        overview:
          "Radiance Splendour offers spacious luxury villas designed with modern architecture in Vedapatti.",
        amenities: [
          "Clubhouse",
          "Gym",
          "Children’s Play Area",
          "Multipurpose Hall",
          "24/7 Security",
          "Power Backup"
        ]
      },

      {
        image: cosmos,
        badge: "Premium Apartments",
        title: "Casagrand Cosmos 2 & 3 BHK Apartments",
        location: "VISWANATHAPURAM, COIMBATORE",
        details: {
          type: "Apartment",
          size: "625 SqFt - 1650 SqFt",
          place: "Viswanathapuram",
          price: "₹29 Lakhs - ₹89 Lakhs"
        },
        overview:
          "Casagrand Cosmos offers modern apartments with premium amenities and excellent connectivity.",
        amenities: [
          "Clubhouse",
          "Swimming Pool",
          "Gym",
          "Children’s Play Area",
          "Indoor Games",
          "24/7 Security"
        ]
      },

      {
        image: kosmos,
        badge: "Luxury Villas",
        title: "Casagrand Cosmos 3 & 4 BHK Villas",
        location: "VISWANATHAPURAM, COIMBATORE",
        details: {
          type: "Villa",
          size: "2500 SqFt - 3441 SqFt",
          place: "Viswanathapuram",
          price: "₹33 Lakhs Onwards"
        },
        overview:
          "Casagrand Cosmos Villas provide spacious premium villas with modern lifestyle amenities.",
        amenities: [
          "Private Garden",
          "Clubhouse",
          "Gym",
          "Multipurpose Hall",
          "Children’s Play Area",
          "24/7 Security"
        ]
      },

      {
        image: prozone,
        badge: "Premium Apartments",
        title: "Prozone Palms 1, 2 & 3 BHK Apartments",
        location: "SARAVANAMPATTI, COIMBATORE",
        details: {
          type: "Apartment",
          size: "721 SqFt - 1753 SqFt",
          place: "Saravanampatti",
          price: "₹1.47 Cr Onwards"
        },
        overview:
          "Prozone Palms offers premium apartments located near major IT hubs in Saravanampatti.",
        amenities: [
          "Clubhouse",
          "Swimming Pool",
          "Gym",
          "Landscaped Garden",
          "Children’s Play Area",
          "24/7 Security"
        ]
      }

      ];


      const location = useLocation();

      useEffect(() => {
        if (location.hash) {
          const el = document.getElementById(location.hash.replace("#", ""));
          if (el) {
            setTimeout(() => {
              el.scrollIntoView({ behavior: "smooth" });
            }, 100);
          }
        }
      }, [location]);


    return (
    <>

    {/* Header */}

    <section
    style={{
    position: "relative",
    backgroundImage: `url(${coimbatorepath})`,
    backgroundAttachment: "fixed",
    backgroundSize: "cover",
    backgroundPosition: "center",
    padding: "120px 20px",
    color: "#fff",
    textAlign: "center"
    }}
    >

      <div
      style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "linear-gradient(10deg, rgba(0, 0, 0, 0.13), rgba(0, 0, 0, 0.13))"
      }}
      ></div>

        <div style={{ position: "relative", zIndex: 2 }}>
        <h1 style={{ fontSize: "3rem", fontWeight: "800", color:"white"}}>Coimbatore</h1>

        <p className='text-white'>We’re Here to Help You Find Your Dream Property</p>

      </div>

    </section>

    <div className="villa-content">
        <h1 className="section-title">Properties in Coimbatore</h1>

        <p className="section-subtitle">
        Experience thoughtfully designed homes crafted for modern lifestyles.
        </p>
    </div>

    {/* PROPERTY LOOP */}

    {properties.map((property, index) => (

    <section className="villa-section" 
            key={index}
            id={property.title.replace(/\s+/g, "-").toLowerCase()}>

        <div className="villa-container">

        <div className="villa-image">

        <img src={property.image} alt={property.title} />

        <div className="villa-badge">{property.badge}</div>

        </div>

        <div className="villa-content">

        <h2>{property.title}</h2>

        <h4 className="location">{property.location}</h4>

        <a href="tel:+919444386103" className="contact-btn">
        Contact Now
        </a>

        <div className="villa-details">

        <div>
        <strong>Project Type:</strong> {property.details.type}
        </div>

        <div>
        <strong>Flat Size:</strong> {property.details.size}
        </div>

        <div>
        <strong>Location:</strong> {property.details.place}
        </div>

        <div>
        <strong>Price:</strong> {property.details.price}
        </div>

        </div>

        <div className="overview">

        <h5>Project Overview</h5>

        <p>{property.overview}</p>

        </div>

        <div className="amenities">

        <h5>Amenities</h5>

        <ul>

        {property.amenities.map((amenity, i) => (

        <li key={i}>

        <i className="fa-solid fa-house"></i> {amenity}

        </li>

        ))}

        </ul>

        </div>

        </div>

        </div>

    </section>

    ))}

    <Cta />

    </>

    );
}

export default Coimbatore